import React from 'react';
import { Button, Table, Modal, Input, Grid, Form, TextArea, Dropdown, Image } from 'semantic-ui-react';
import $ from "jquery";

import Loading from '../../loading';
import Server from '../../../functions/server';

class GetVideos extends React.Component {

  state = {
    videos: []
  }


  getVideos() {
    if (!this.props.menuPermission.add) {
      alert('You Are Not Allow To Add Video');
      return;
    }
    let context = this;
    context.setState({ load: true, message: 'Getting Model' });
    $.ajax({
      type: 'POST', data: { id: context.props.id },
      url: Server() + 'machinemodel/getvideos.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setState({ videos: data, load: false, open: true })
        } catch (e) {
          alert('Error!!!')
          context.setState({ load: false })
        }
      },
      error: function (e) {
        alert(e)
        context.setState({ load: false });
      }
    });
  }

  addURL() {
    let context = this;
    if (!this.state.url) {
      alert('Add Url!!!');
      return;
    }
    $.ajax({
      type: 'POST', data: { id: context.props.id, url: this.state.url },
      url: Server() + 'machinemodel/addvideos.php',
      success: function(data) {
        if (data == 1) {
          alert('Success');
          context.getVideos();
          context.setState({ url: '' })
        }
        else {
          alert('Error to Add!!!');
        }
      },
      error: function (e) {
        alert(e)
        context.setState({ load: false });
      }
    });
  }

  onChangeText = (type) => (e, {value}) => { this.setState({ [type]: value }) }

  delete(id) {
    let context = this;
    $.ajax({
      type: 'POST', data: { id },
      url: Server() + 'machinemodel/deletevideos.php',
      success: function(data) {
        let videos = context.state.videos;
        let video = [];
        if (data == 1) {
          alert('Success');
          videos.map((c) => { if (c.id != id) { video.push(c); } });
          context.setState({ url: '', videos: video })
        }
        else {
          alert('Error to Add!!!');
        }
      },
      error: function (e) {
        alert(e)
        context.setState({ load: false });
      }
    });
  }

  render() {
    let i = 1;
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <center style={{color: 'blue', cursor: 'pointer', fortWeight: 'bold'}} onClick={this.getVideos.bind(this)}>Videos</center>

        <Modal open={this.state.open} onClose={ () => { this.setState({ open: false }) }}>
          <Modal.Content>
              <table id='table' width="100%">
                <tr>
                    <th id='th' style={{width: '8%'}}><center>Sino</center></th>
                    <th id='th'><center>Video Url</center></th>
                    <th id='th' style={{width: '10%', cursor: 'pointer'}}><center>Delete</center></th>
                </tr>
                { this.state.videos.map((c) => {
                    return (
                      <tr>
                        <td><center>{i++}</center></td>
                        <td><a href={c.url} target="_blank">{c.url}</a></td>
                        <td style={{width: '10%', cursor: 'pointer'}} onClick={this.delete.bind(this, c.id)}><center>Delete</center></td>
                      </tr>
                    )
                  })
                }
              </table>
          </Modal.Content>
          <Modal.Actions>
            <Grid>
              <Grid.Column mobile={16} tablet={16} computer={12}>
                <Input fluid focus placeholder={'Add Video Link'} onChange={this.onChangeText('url')} value={this.state.url} />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={2}>
                <Button onClick={this.addURL.bind(this)}>Add</Button>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={2}>
                <Button onClick={ () => { this.setState({ open: false }) }} negative>
                  Close
                </Button>
              </Grid.Column>
            </Grid>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default GetVideos;
